import React from 'react';
import PropTypes from 'prop-types';

const Content = (props) => {
  const { children, className } = props;

  return <div className={`blueprint-content ${className}`}>{children}</div>;
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Content.defaultProps = {
  className: '',
};

export default Content;
